import { defineSseEvent } from '@terra/shared-sse-contracts';
import { TargetTypeSchema } from '@terra/shared-schemas-orchestrator';
import { z } from 'zod';
import { DirectoryScanStatusSchema } from './directory-scan.schema';

export const DIRECTORY_SCAN_STATUS_CHANGED_SSE_TYPE =
  'DIRECTORY_SCAN_STATUS_CHANGED' as const;

export const DirectoryScanStatusChangedSsePayloadSchema = z.object({
  scanId: z.string(),
  applicationId: z.string(),
  targetType: TargetTypeSchema,
  status: DirectoryScanStatusSchema,
});

export const DIRECTORY_SCAN_STATUS_CHANGED_SSE_EVENT = defineSseEvent({
  type: DIRECTORY_SCAN_STATUS_CHANGED_SSE_TYPE,
  payload: DirectoryScanStatusChangedSsePayloadSchema,
  channelPrefix: 'directory-scan',
  channelKey: (payload) => payload.applicationId,
  target: {
    type: (payload) => payload.targetType,
    id: (payload) => payload.applicationId,
  },
});

export type DirectoryScanStatusChangedSsePayload = z.infer<
  typeof DirectoryScanStatusChangedSsePayloadSchema
>;
